var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsGuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.399902,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5063 15.7463C16.4863 15.7463 16.473 15.7463 16.453 15.7463C16.4196 15.7397 16.373 15.7397 16.333 15.7463C14.3996 15.6863 12.9396 14.1663 12.9396 12.293C12.9396 10.3863 14.493 8.83301 16.3996 8.83301C18.3063 8.83301 19.8596 10.3863 19.8596 12.293C19.853 14.1663 18.3863 15.6863 16.5263 15.7463C16.5196 15.7463 16.513 15.7463 16.5063 15.7463ZM16.3996 9.83301C15.0463 9.83301 13.9396 10.9397 13.9396 12.293C13.9396 13.6263 14.9796 14.6997 16.3063 14.7463C16.3396 14.7397 16.433 14.7397 16.5196 14.7463C17.8263 14.6863 18.853 13.613 18.8596 12.293C18.8596 10.9397 17.753 9.83301 16.3996 9.83301Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.513 23.033C15.2063 23.033 13.893 22.6997 12.8996 22.033C11.973 21.4197 11.4663 20.5797 11.4663 19.6663C11.4663 18.753 11.973 17.9063 12.8996 17.2863C14.8996 15.9597 18.1396 15.9597 20.1263 17.2863C21.0463 17.8997 21.5596 18.7397 21.5596 19.653C21.5596 20.5663 21.053 21.413 20.1263 22.033C19.1263 22.6997 17.8196 23.033 16.513 23.033ZM13.453 18.1263C12.813 18.553 12.4663 19.0997 12.4663 19.673C12.4663 20.2397 12.8196 20.7863 13.453 21.2063C15.113 22.3197 17.913 22.3197 19.573 21.2063C20.213 20.7797 20.5596 20.233 20.5596 19.6597C20.5596 19.093 20.2063 18.5463 19.573 18.1263C17.913 17.0197 15.113 17.0197 13.453 18.1263Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsGuests);
export default __webpack_public_path__ + "static/media/statistics-guests.d18ab5daecaf678a595c17dadf0754a3.svg";
export { ForwardRef as ReactComponent };